import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, CardContent, Chip, List, ListItem, Typography, useTheme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { getExchangePickList } from "../ExchangeServingList/utils";
import { formatAmbiguousServingAmountWithTotalWeight } from "../ServingAmount/utils";
const useStyles = makeStyles((theme) => createStyles({
    root: {
        margin: theme.spacing(2),
        height: `calc(100% - ${theme.spacing(4)})`,
    },
    content: {
        boxSizing: "border-box",
        height: "100%",
        display: "grid",
        gridTemplateColumns: "auto",
        gridTemplateRows: "auto minmax(0, 1fr)",
    },
    header: {
        display: "flex",
        justifyContent: "space-around",
        gridRowStart: 1,
        gridColumnStart: 1,
    },
    pickList: {
        overflowY: "auto",
        overflowX: "hidden",
        paddingLeft: theme.spacing(2),
        marginBottom: 0,
        gridRowStart: 2,
        gridColumnStart: 1,
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignContent: "start",
    },
    pickItem: {
        width: `calc(50% - ${theme.spacing(2)})`,
        paddingBottom: theme.spacing(0.5),
        paddingRight: theme.spacing(2),
    },
    ellipses: {
        lineHeight: "12px",
        width: "100%",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "clip",
    },
    exchangeAmountChip: {
        marginLeft: 5,
        marginRight: 5,
        height: 20,
        color: "white",
    },
    row: {
        display: "flex",
        alignItems: "center",
    },
}));
export const ExchangeAmountPreviewCard = ({ exchangeAmount, servingList }) => {
    const { palette: { greyscale }, } = useTheme();
    const classes = useStyles();
    const { exchange, amount, pickListServingIds } = exchangeAmount;
    const pickList = getExchangePickList(servingList, pickListServingIds);
    return (_jsx(Card, { className: classes.root, children: _jsxs(CardContent, { className: classes.content, children: [_jsxs("div", { className: classes.header, children: [_jsx(Typography, { style: { color: greyscale[500] }, component: "span", children: exchange.name }), _jsxs("div", { className: classes.row, children: [_jsxs(Typography, { color: "textSecondary", component: "span", children: [" ", "pick"] }), _jsx(Chip, { className: classes.exchangeAmountChip, style: { backgroundColor: greyscale[500] }, size: "small", label: amount }), _jsxs(Typography, { color: "textSecondary", component: "span", children: [" ", "servings"] })] })] }), _jsx(List, { sx: {
                        listStyleType: "disc",
                        pl: 2,
                        "& .MuiListItem-root": {
                            display: "list-item",
                        },
                    }, children: pickList.map(sa => (_jsx(ListItem, { sx: { p: 0 }, children: _jsxs(Typography, { variant: "subtitle1", sx: { lineHeight: 1, fontSize: "10px", whiteSpace: "initial" }, children: [sa.serving.foodOrRecipe.name, " - ", formatAmbiguousServingAmountWithTotalWeight(sa)] }) }, sa.id))) })] }) }));
};
//# sourceMappingURL=PreviewCard.js.map